<template>
  <ModalWrapperComponent dialog-name="MoveMySubscriptionComponent" :show-dialog="showDialog" @close-modal="closeModal">
    <template #header>
      {{ tn("headerH1") }}
    </template>
    <template #content>
      <p>
        {{ tn("moveNicknameLabel") }}
        <strong>{{ nickname }}</strong>
      </p>
      <p>{{ tn("moveNicknameInstruction") }}</p>

      <h3 class="mb">{{ tn("moveNicknameOptions") }}</h3>
      <ul class="form">
        <li class="radio">
          <input id="newbackup" type="radio" name="method" value="newbackup" @click="setInstallType('Transfer')" />

          <i18n-t keypath="WindowsMoveSubscriptionComponent.moveAndBackup" tag="label" for="newbackup" scope="global">
            <template #backup>
              <strong>{{ tn("startNewBackup") }}</strong>
            </template>
          </i18n-t>
        </li>
        <li>
          <i18n-t keypath="WindowsMoveSubscriptionComponent.moveAndNote" tag="p" class="danger-text" scope="global">
            <template #note>
              <strong>{{ tn("note") }}</strong>
            </template>
          </i18n-t>
        </li>
        <li class="radio">
          <input id="recover" type="radio" name="method" value="recover" @click="setInstallType('Recover')" />
          <i18n-t keypath="WindowsMoveSubscriptionComponent.moveAndTransfer" tag="label" for="recover" scope="global">
            <template #transfer>
              <strong>{{ tn("transferFiles") }}</strong>
            </template>
          </i18n-t>
        </li>
      </ul>
    </template>
    <template #footer>
      <button id="btnCancelChanges" type="button" class="btn-link mr-half" @click="closeModal()">
        {{ tn("footerButtonCancel") }}
      </button>
      <button
        id="btnSaveChanges"
        type="button"
        :disabled="!isOptionSelected"
        class="btn-primary"
        @click="handleSaveModal()"
      >
        {{ tn("next") }}
      </button>
    </template>
  </ModalWrapperComponent>
</template>

<script lang="ts">
//cSpell:ignore newbackup

import { defineComponent, PropType, ref, computed } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { IDevice } from "@/common/api/unifiedPortal/interfaces";
import { getOsFamily } from "@/common/browserDetect";
import ModalWrapperComponent from "@/components/shared/dialogs/ModalWrapper.vue";

const componentName = "WindowsMoveSubscriptionComponent";

export default defineComponent({
  name: componentName,
  components: { ModalWrapperComponent },
  props: {
    device: {
      type: Object as PropType<IDevice>,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["save", "cancel"],

  setup(props, context) {
    logEvent("created", componentName, props.device);

    const oldComputerOs = ref<string>(props.device.description);
    const newComputerOs = computed(() => {
      return getOsFamily().toLowerCase();
    });
    const nickname = ref<string>(props.device.description);
    const installType = ref<string>("");

    const isOptionSelected = computed(() => {
      return installType.value;
    });

    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }

    function setInstallType(type: string) {
      installType.value = type;
    }

    function handleSaveModal() {
      context.emit("save", installType.value);
    }

    function closeModal() {
      context.emit("cancel");
    }

    //Expose to template
    return {
      tn,
      oldComputerOs,
      newComputerOs,
      nickname,
      installType,
      isOptionSelected,
      setInstallType,
      handleSaveModal,
      closeModal,
    };
  },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";
.danger-text {
  margin-left: 27px;
}
</style>
